














import store from '@/store';
import Global from '@/common/global.js'

export default
  props:
    # アイテムリスト
    listData:
      type: Array
      default: []
    # デフォルト値
    defaultValue:
      type: String
      default: null
    # Props名
    name:
      type: String
      default: ''
    # リードオンリー
    readonly:
      type: Boolean
      default: false
    blank:
      type: Boolean
      default: false
    # GROUP
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
    no_store:
      type: Boolean
      default: false
    after_zindex:
      type: Boolean
      default: false
    disabled:
      type: Boolean
      default: false
    color_white:
      type: Boolean
      default: false
  watch: {
    listData: (v) ->
      @listData = v
      if @blank
        if @listData.length > 0 && @listData[0].id != ''
          @listData.unshift({id: '', name: ''})
    defaultValue: (v) ->
      @value = v
  }

  data: () ->
    value: ''
    list: @listData

  created: () ->
    if @blank
      if @listData.length > 0 && @listData[0].id != ''
        @listData.unshift({id: '', name: ''})

  computed: {
    val: () ->
      @_saveStore(@value)
      return @value

    isDetailChange: () ->
      if !@no_store
        v = Global.getGroupIndexValue(@group, @index, @name)
        if v != ''
          @value = v
        else
          @value = @defaultValue
        return store.getters.isSetDetail
      return ''
  }

  methods: {
    change: (e) ->
      @_saveStore(e.target.value)
      @$emit('change', {val: e.target.value, name: @name, index: @index})
    click: (e) ->
      @$emit('click')
    _saveStore: (value) ->
      if !@no_store
        store.dispatch('setPostParam', {label: @name, value: value, index: @index, group: @group})
  }
